// Curated country list. Mexico first (default), then common ones, then the rest alpha.
export const COUNTRIES = [
  { code: 'MX', en: 'Mexico', es: 'México' },
  { code: 'US', en: 'United States', es: 'Estados Unidos' },
  { code: 'CA', en: 'Canada', es: 'Canadá' },
  { code: 'GB', en: 'United Kingdom', es: 'Reino Unido' },
  { code: 'ES', en: 'Spain', es: 'España' },
  { code: 'FR', en: 'France', es: 'Francia' },
  { code: 'DE', en: 'Germany', es: 'Alemania' },
  { code: 'IT', en: 'Italy', es: 'Italia' },
  { code: 'NL', en: 'Netherlands', es: 'Países Bajos' },
  { code: 'CH', en: 'Switzerland', es: 'Suiza' },
  { code: 'BE', en: 'Belgium', es: 'Bélgica' },
  { code: 'IE', en: 'Ireland', es: 'Irlanda' },
  { code: 'PT', en: 'Portugal', es: 'Portugal' },
  { code: 'AR', en: 'Argentina', es: 'Argentina' },
  { code: 'BR', en: 'Brazil', es: 'Brasil' },
  { code: 'CL', en: 'Chile', es: 'Chile' },
  { code: 'CO', en: 'Colombia', es: 'Colombia' },
  { code: 'PE', en: 'Peru', es: 'Perú' },
  { code: 'UY', en: 'Uruguay', es: 'Uruguay' },
  { code: 'AU', en: 'Australia', es: 'Australia' },
  { code: 'JP', en: 'Japan', es: 'Japón' },
  { code: 'OTHER', en: 'Other country', es: 'Otro país' },
];

export const countryName = (code, lang) => {
  const c = COUNTRIES.find((x) => x.code === (code || '').toUpperCase());
  return c ? (lang === 'es' ? c.es : c.en) : code;
};
